export const VALUE_PLACEHOLDER = {
  doubleDash: '--',
  notFound: 'Поле не найдено'
} as const
